/**
 * Class names for Delimiter
 */
// eslint-disable-next-line etc/no-const-enum
export const enum DelimiterClasses {
    /**
     * Class name to specify this delimiter is before an entity
     */
    DELIMITER_BEFORE = 'entityDelimiterBefore',

    /**
     *  Class name to specify this delimiter is after an entity
     */
    DELIMITER_AFTER = 'entityDelimiterAfter',
}
